
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"9","height":"11","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M8.25.336v2.36h-.766a6.5 6.5 0 00-.242-.673 2.947 2.947 0 00-.258-.484 1.223 1.223 0 00-.296-.312.87.87 0 00-.375-.157 2.532 2.532 0 00-.524-.047H3.32v4.094h1.672c.23 0 .409-.031.54-.094a.772.772 0 00.32-.335c.088-.157.171-.402.25-.735h.734v3h-.734c-.073-.312-.154-.547-.243-.703a.826.826 0 00-.32-.344c-.12-.067-.302-.101-.547-.101H3.32v4.508h2.43c.255 0 .46-.021.617-.063.162-.047.3-.122.414-.227.115-.109.216-.25.305-.421.088-.172.161-.35.219-.532.062-.187.146-.458.25-.812h.773L8.18 11H.945v-.383c.323-.083.54-.174.649-.273.11-.104.18-.25.21-.438.037-.187.055-.474.055-.86V2.29c0-.36-.013-.62-.039-.781a.911.911 0 00-.133-.383.593.593 0 00-.234-.219A2.428 2.428 0 00.945.72V.336H8.25z","fill":"currentColor"}})])
          )
        }
      }
    